<template>
  <div id="screen" class="ui basic container segment" style="overflow:auto">
    <div class="ui purple segment">
      <h3 style="text-align: center">Sales photo shoot</h3>
      <div class="ui left aligned basic segment">
        <form id="locationform">
          <div class="field">
            <label>Location:</label>
            <select id="locationselector" v-model="selectedlocation" @change="locationChanged" class="ui fluid dropdown">
              <option value="-1"></option>
              <option v-for="(loc,index) in this.$locations" :key="index" :value="loc.id">{{ loc.companyname }}</option>
            </select>
          </div>
        </form>
      </div>

      <div class="ui basic segment" v-if="selectedlocation != -1" style="text-align: center">
        <div class="ui header">Registration plate</div>
        <button v-if="!regTaken" class="ui primary button" @click="takePlatePhoto">Add a new plate</button>
        <div v-if="regTaken" class="ui center aligned one cards">
          <div class="card">
            <div class="image">
              <div style="position: absolute;z-index: 0;width: 100%;">
                <button class="ui right floated mini circular icon button" style="margin-top: 1em;margin-right: 1em;" @click="takePlatePhoto">
                  <i class="refresh icon"></i>
                </button>
              </div>
              <img :src="reg.p" id="platephotoimg">
            </div>
          </div>
        </div>
      </div>

      <div class="ui basic segment" v-if="regTaken" style="text-align: center">
        <div class="ui header">Vehicle photos ({{ photos.length }} photos)</div>
        <button class="ui primary button" @click="takePhoto">Add a new photo</button>
        <button class="ui right floated primary button" @click="savePhotoShoot" v-if="photos.length>0">Done, save</button>
        <div id="vehphotos" class="ui fluid stackable cards" style="margin-top:1em">
          <div class="card" v-for="(r, index) in photos" :key="index">
            <div class="image">
              <div style="position: absolute;z-index: 0;width: 100%;">
                <button class="ui right floated mini circular icon button" style="margin-top: 1em;margin-right: 1em;" @click="removeVehiclePhoto(index)">
                  <i class="close icon"></i>
                </button>
              </div>
              <img :src="r">
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
  <div id="modalcontainer">

    <div class="ui modal" id="platemodal" style="margin:auto;position:static">
      <i class="close icon" @click="closePlatePhotoModal"></i>
      <div class="header">Take a photo</div>
      <div class="image content">
        <div class="ui medium image">
          <video id="platevideo" autoplay="true" muted playsinline="true" style="width:100%;aspect-ratio: 4;object-fit: cover;"></video>
        </div>
        <div class="description">
          <div class="ui header">How to take a photo</div>
          <p>
            Please move your camera to position the number plate to fit in the rectangle on the left side.<br>
            Hold camera still and hit the button below<br><br>When you're done, the system will try to recognise it right away when you are online.
          </p>
          <div style="text-align:center"><button class="ui circular huge primary icon button" id="camerabtn" @click="takePlatePicture"><i class="camera icon"></i></button></div>
          <div class="ui error message" v-if="cameraError">Unable to start video device</div>
        </div>
      </div>
      <div class="actions">
        <button class="ui black deny button" @click="closePlatePhotoModal">
          Cancel
        </button>
      </div>
    </div>

    <div class="ui overlay fullscreen modal" id="photomodal" style="margin:auto;position:static">
      <i class="close icon" @click="closePhotoModal"></i>
      <div class="header">Take a photo</div>
      <div class="image content">
        <div class="ui image">
          <video id="vehvideo" autoplay="true" muted playsinline="true" style="width:100%;object-fit: cover"></video>
        </div>
        <div class="description">
          <div style="text-align:center"><button class="ui circular huge primary icon button" @click="takePicture"><i class="camera icon"></i></button></div>
          <div class="ui error message" v-if="cameraError">Unable to start video device</div>
        </div>
      </div>
      <div class="actions">
        <button class="ui black deny button" @click="closePhotoModal">
          Cancel
        </button>
      </div>
    </div>

  </div>
</template>

<style>
  /* The Modal (background) */
  #modalcontainer {
    display: none; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 1; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0,0,0); /* Fallback color */
    background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
  }

</style>
<script>

  function diff (num1, num2) {
    if (num1 > num2) {
      return num1 - num2
    } else {
      return num2 - num1
    }
  }

  export default {
    data() {
      return {
        selectedlocation:-1,
        regTaken:false,
        reg:{},
        video:null,
        cameraError:null,
        photos:[],
        videos:null
      }
    },
    methods: {
      savePhotoShoot() {
        var ph = [];
        for (var i=0; i<this.photos.length; i++) {
          ph.push(this.photos[i]);
        }
        console.log('savePhotoShoot');
        // get plate image, get images
        this.$offlineUploader.addItem(this.$host+'/savevpsmp', {
          // method:'POST',
          // headers: {'Content-type':'application/json'},
          // mode:'cors',
          // credentials:'include',
          location: this.selectedlocation,
          plate: this.reg.p,
          photos: ph
        });
        alert('We have saved your photo shoot. It will be uploaded when you are online.');
        this.$router.push('/');
      },
      removeVehiclePhoto(i) {
        this.photos.splice(i,1);
      },
      takePlatePicture() {
        var canvas = document.createElement('canvas');
        const context = canvas.getContext("2d");
        canvas.width = this.video.videoWidth;
        canvas.height = this.video.videoWidth/4;

        context.drawImage(this.video, 0, (this.video.videoHeight - (this.video.videoWidth/4))/2, this.video.videoWidth, this.video.videoWidth/4, 0, 0, this.video.videoWidth, this.video.videoWidth/4);
        const data = canvas.toDataURL("image/jpeg");

        this.reg = {p:data};
        this.closePlatePhotoModal();
        this.regTaken = true;
      },
      takePicture() {
        var canvas = document.createElement('canvas');
        const context = canvas.getContext("2d");
        canvas.width = this.video.videoWidth;
        canvas.height = this.video.videoHeight;

        context.drawImage(this.video, 0, 0, this.video.videoWidth, this.video.videoHeight, 0, 0, this.video.videoWidth, this.video.videoHeight);
        const data = canvas.toDataURL("image/jpeg");

        this.photos.unshift(data);
        this.closePhotoModal();
      },
      closePlatePhotoModal() {
        document.querySelector('#modalcontainer').style.display='none';
        document.querySelector('#platemodal').className = 'ui modal';
        if (this.videos) {
          this.videos.getTracks().forEach( (track) => {
            track.stop();
          });

          this.videos = null;
        }
      },
      closePhotoModal() {
        document.querySelector('#modalcontainer').style.display='none';
        document.querySelector('#photomodal').className = 'ui modal';
        if (this.videos) {
          this.videos.getTracks().forEach( (track) => {
            track.stop();
          });

          this.videos = null;
        }
      },
      startPlateCamera() {
        this.cameraError=false;
        var thiz = this;
        var cn;

        document.querySelector('#modalcontainer').style.display='flex';
        cn = document.querySelector('#platemodal').className.split(' ');
        if (cn.indexOf('active') == -1) {
          cn.push('active');
          document.querySelector('#platemodal').className = cn.join(' ');
        }

        navigator.mediaDevices.getUserMedia({
          audio: false,
          video: {
            facingMode: "environment"
          }
        }).then((s) => {
          thiz.video = document.getElementById('platevideo');

          try {
            thiz.video.srcObject = s;
            thiz.videos = s;
          }
          catch(e){
            console.log(e);
            alert(e.toString());
          }
        }).catch(err=>{
          console.log('system error #165', err);
          thiz.cameraError = true;
        });
      },
      startPhotoCamera() {
        this.cameraError=false;
        var thiz = this;
        var cn;

        document.querySelector('#modalcontainer').style.display='flex';
        cn = document.querySelector('#photomodal').className.split(' ');
        if (cn.indexOf('active') == -1) {
          cn.push('active');
          document.querySelector('#photomodal').className = cn.join(' ');
        }

        navigator.mediaDevices.getUserMedia({
          audio: false,
          video: {
            facingMode: "environment",
            width: { min: 1280 },
            height: { min: 720 }
          }
        }).then((s) => {
          thiz.video = document.getElementById('vehvideo');

          try {
            thiz.video.srcObject = s;
            thiz.videos = s;
          }
          catch(e){
            console.log(e);
            alert(e.toString());
          }
        }).catch(err=>{
          console.log('system error #165', err);
          thiz.cameraError = true;
        });
      },
      takePlatePhoto() {
        this.startPlateCamera();
      },
      takePhoto() {
        this.startPhotoCamera();
      },
      getLocation() {
        var thiz = this;
        if(navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((event) =>{
              var i,a,o,op=-1,od,nd;
              
              for (i=0; i< thiz.$locations.length; i++) {
                if (!(thiz.$locations[i].lat)) {
                  continue;
                }

                if (op === -1) {
                  op = i;
                  a = diff(event.coords.latitude, thiz.$locations[i].lat);
                  o = diff(event.coords.longitude, thiz.$locations[i].lon);

                  od = a*a+o*o;
                }
                else {
                  a = diff(event.coords.latitude, thiz.$locations[i].lat);
                  o = diff(event.coords.longitude, thiz.$locations[i].lon);
                  nd = a*a+o*o;

                  if (nd < od) {
                    od=nd;
                    op = i;
                  }
                }
              }
              thiz.selectedlocation = thiz.$locations[op].id;

            },(e)=>{
              console.log(e);
            },{enableHighAccuracy:true}
          );
        } else {
            alert("Your browser doesn't support Geolocation");
        }
      }
    },
    mounted() {
      setTimeout(()=>{
        const e = document.querySelector('#purpleheader').animate({height:"130px"}, 500)
        e.onfinish = ()=>{
          document.querySelector('#purpleheader').style.height = "130px";
        };
      },0);
      this.getLocation();
    }
  }
</script>
